import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Checkbox,
  Box,
  Text,
  Divider,
} from "@chakra-ui/react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import i18next from "i18next";
import { languageMapping } from "../../../../i18n/config";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

const GameMarqueeModal = ({ isOpen, onClose, gameMarquee }) => {
  const { t } = useTranslation();

  const currentLng = languageMapping(i18next.language) || "en_US";
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    if (isOpen && gameMarquee.length > 0) {
      const allHidden = gameMarquee.every((item) => {
        const data = item[currentLng] || item;
        if (data && data.marquee_id) {
          return (
            Cookies.get(`hide_game_marquee_${data.marquee_id}`) === "true"
          );
        }
        return false;
      });
      setDontShowAgain(allHidden);
    }
  }, [isOpen, gameMarquee, currentLng]);

  const handleDontShowChange = (e) => {
    const isChecked = e.target.checked;
    setDontShowAgain(isChecked);

    gameMarquee.forEach((item) => {
      const data = item[currentLng] || item;
      if (data && data.marquee_id) {
        if (isChecked) {
          // Expiration in 30 minutes (30 / 1440 days)
          Cookies.set(`hide_game_marquee_${data.marquee_id}`, "true", {
            expires: 30 / 1440,
          });
        } else {
          Cookies.remove(`hide_game_marquee_${data.marquee_id}`);
        }
      }
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      colorScheme="blackAlpha"
      isCentered
      size="sm"
    >
      <ModalOverlay />
      <ModalContent mx={4}>
        <ModalHeader fontSize="lg">{t("common.遊戲公告")}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          {gameMarquee.length > 0 && (
            <Box mb={4}>
              <Splide
                options={{
                  // type: "loop",
                  focus: "center",
                  perMove: 1,
                  autoplay: true,
                  arrows: false,
                  pagination: true,
                }}
              >
                {gameMarquee.map((item, index) => {
                  const data = item[currentLng] || item;
                  if (!data) return null;
                  return (
                    <SplideSlide key={data.marquee_id || index}>
                      <Box
                        p={0}
                        textAlign="center"
                        flex={1}
                        display="flex"
                        flexDirection="column"
                        justifyContent="flex-start"
                      >
                        <Text fontWeight="bold" fontSize="xl" mb={3}>
                          {data.subject}
                        </Text>
                        <Divider mb={3} />
                        <Text whiteSpace="pre-wrap" fontSize="sm">
                          {data.content}
                        </Text>
                      </Box>
                    </SplideSlide>
                  );
                })}
              </Splide>
            </Box>
          )}
          <Box display="flex" justifyContent="flex-end" px={4}>
            <Checkbox
              isChecked={dontShowAgain}
              onChange={handleDontShowChange}
              colorScheme="blue"
            >
              {t("common.noShow")}
            </Checkbox>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default GameMarqueeModal;
